import messagesMiddleware from './messages/middleware';

const listeningModeMiddleware = store => next => (action) => {
  messagesMiddleware(store)(next)(action);
};

export default listeningModeMiddleware;
